import MaterialIcon from '@components/common/MaterialIcon';
import ButtonT from '@components/tailwind-components/Button/ButtonT';
import { SETTINGS_PAGE_BOT_GENERAL_ROUTE } from '@constants/routes';
import { useLanguage } from '@hooks/flow/language/useLangauge';
import { useModal } from '@hooks/modal/useModal';
import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router';

// Every webclient text is stored per bot language, so without any configured
// language there is no input to render for them. Provisioning does not set
// the languages, so a new studio starts without them.
const MissingBotLanguagesNotice: React.FC<{ className?: string }> = ({
  className = '',
}) => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { hideModal } = useModal();
  const { languages } = useLanguage();

  if (languages.length) {
    return null;
  }

  // The notice also shows inside the webclient config modal, which would stay
  // open over the settings page.
  const openLanguageSettings = () => {
    hideModal();
    navigate(SETTINGS_PAGE_BOT_GENERAL_ROUTE);
  };

  return (
    <div
      className={`flex items-center gap-2 px-3 py-2 bg-amber-50 border border-amber-200 rounded-lg ${className}`}>
      <MaterialIcon
        icon='warning'
        classes={['text-amber-500', 'text-base', 'flex-shrink-0']}
      />
      <p className='flex-1 text-tiny text-amber-800'>
        {t('settings.webclient.config.form.no-bot-languages.description')}
      </p>
      <ButtonT
        type='button'
        styling='outline-amber'
        size='tiny'
        rounding='md'
        className='flex-shrink-0 whitespace-nowrap !shadow-none'
        onClick={openLanguageSettings}>
        {t('settings.webclient.config.form.no-bot-languages.action')}
      </ButtonT>
    </div>
  );
};

export default MissingBotLanguagesNotice;
